// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__aPk5e","rotation":"SmallLoader_rotation__hBo8s"};